export const attachmentEditMode = {
  "type": "fgAttachmentConfiguration",
  "subtype": "Q",
  "icon": "fa fa-file",
  "name": "FG Attachment",
  "text": "FG Attachment",
  "heading": "FG Attachment",
  "footerText": "From Bluescope Tech",
  "label": "DMS Event Id",
  "condition": {
 
  },
  "uuid":  crypto.randomUUID(),
  "attachementPurposeList": [
    
  ],
  "isCmsDocument": false,
  "isMultiple": true,
  "manualApiKey": true,
  "key": "DMS_EVENT_ID",
  "emptyStateContent": "There are no documents attached",
  "contentAfterUpload": "",
  "hideUploadPart": false,
  "styles": {
    "min-height": "",
    "max-height": "",
    "max-width": "",
    "min-width": ""
  },
  "mappingField": [
    {
      "targetFieldCode": "FILE_NAME",
      "sourceFieldCode": "fileName",
      "$$hashKey": "object:2474"
    }
  ],
  "hideInfoIcon": true,
  "templateB": false,
  "validation": {
    "required": true
  },
  "fileLimits": false,
  "maxFileLimits": null,
  "showOnlyPurposeCode": null,
  "disableBrowseAction": false,
  "hidden": false,
  "reqMappingFields": [
    {
      "targetFieldCode": "screen",
      "sourceFieldCode": "Upload",
      "$$hashKey": "object:12313"
    },
    {
      "targetFieldCode": "layoutVersionId",
      "sourceFieldCode": "LAYOUT_TEMPLATE_VERSION_ID",
      "isDynamic": true,
      "$$hashKey": "object:12316"
    },
    {
      "targetFieldCode": "layoutId",
      "sourceFieldCode": "LAYOUT_TEMPLATE_ID",
      "isDynamic": true,
      "$$hashKey": "object:12319"
    }
  ],
  "customStyle": "text-align:left;",
  "isLabelContent": "",
  "isSupportedFileFormat": "",
  "isManualBindingKey": true,
  "isRelationship": false,
  "linkModel": "",
  "titleRequired": false,
  "isValidate": false,
  "fileNameValidationEnabled": false,
  "titlePattern": "",
  "titleMinLength": "",
  "titleMaxLength": "",
  "fileNamePattern": "",
  "fileNameMaxLength": "",
  "saveType": "BASE64",
  "required": false,
  "minLength": null,
  "maxLength": null,
  "selectedDatatype": "text",
  "tooltip": null,
  "isImagePreview": false
}